import { fetch } from '@maxtropy/components';
import { GGDStatus } from '../pages/LightingControl/util';

export interface DeviceListRequest {
  deviceName?: string;
  status?: GGDStatus;
  page?: number;
  size?: number;
}

export interface PageResponse<T> {
  page: number;
  size: number;
  total: number;
  list: Array<T>;
}

export interface DeviceListResponse {
  locationRemark?: string; // 位置备注
  deviceId: number; // 设备ID
  name: string; // 设备名称
  status: GGDStatus; // 设备状态（开关）
  power: number; // 功率
  temperature: number; // 温度
  avoltage: number; // A相电压
  bvoltage: number; // B相电压
  cvoltage: number; // C相电压
  acurrent: number; // A相电流
  bcurrent: number; // B相电流
  ccurrent: number; // C相电流
}

export interface BatchOperateRequest {
  deviceIds: Array<number>;
  status: GGDStatus;
  distributeMan?: string;
}

export function getDeviceList(params: DeviceListRequest): Promise<PageResponse<DeviceListResponse>> {
  return fetch(
    // `http://10.50.16.213:40001/mock/487/api/v2/ggd/mobile/device/page`,
    `/api/v2/ggd/mobile/device/page`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export interface BatchOperateRequest {
  deviceIds: Array<number>;
  status: GGDStatus;
  distributeMan?: string;
}
export function batchOperateStatus(params: BatchOperateRequest) {
  return fetch(
    `/api/v2/ggd/batchOperate/status`,
    // `http://10.50.16.213:40001/mock/487/api/v2/ggd/batchOperate/status`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export interface GgdMobileLocationListRequest {}
export interface GgdMobileLocationListResponse {
  list: {
    locationRemark: string;
    deviceNum: number;
  }[];
}

export function apiV2GgdMobileLocationListPost(
  params: GgdMobileLocationListRequest
): Promise<GgdMobileLocationListResponse> {
  return fetch(
    `/api/v2/ggd/mobile/location/list`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
